export default __webpack_public_path__ + "roboto-v27-latin-italic.723317.woff2";